import { Link, Outlet } from "react-router";

import { ThemeControl } from "@/theme/theme-control";
import { Button } from "@/ui/button";

import { pausedFeatures } from "../features";
import { Logo } from "../ui/logo";

// Frame the public story with the same quiet confidence as the archive itself.
export default function MarketingLayout() {
  return (
    <div className="mx-auto flex min-h-dvh w-[calc(100%-2rem)] max-w-7xl flex-col sm:w-[calc(100%-3rem)]">
      <header className="flex h-20 items-center justify-between">
        <Logo linkTo="/" />

        <nav
          aria-label="Public navigation"
          className="hidden items-center gap-7 text-sm md:flex"
        >
          <Link className="underline-decoration hover:underline" to="/#why">
            Why Paused
          </Link>
          <Link
            className="underline-decoration hover:underline"
            to="/#how-it-works"
          >
            How it works
          </Link>
          <Link className="underline-decoration hover:underline" to="/#sources">
            {pausedFeatures.youtube ? "RSS and YouTube" : "RSS podcasts"}
          </Link>
          <Link className="underline-decoration hover:underline" to="/pricing">
            Pricing
          </Link>
        </nav>

        <div className="flex items-center gap-1.5 sm:gap-2">
          <ThemeControl className="hidden sm:flex" />
          <Button
            asChild
            className="hidden h-10 sm:inline-flex"
            variant="ghost"
          >
            <Link to="/login">Sign in</Link>
          </Button>
          <Button asChild className="h-10">
            <Link to="/home">Open your archive</Link>
          </Button>
        </div>
      </header>

      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>

      <footer className="text-muted-foreground flex flex-col gap-5 border-t py-8 text-sm sm:flex-row sm:items-center sm:justify-between sm:py-10">
        <div>
          <p>© {new Date().getFullYear()} Paused FYI</p>
          <p className="mt-1">Pause the episode. Keep the thought.</p>
        </div>
        <div className="flex items-center gap-5">
          <Link className="underline-decoration hover:underline" to="/pricing">
            Pricing
          </Link>
          <Link className="underline-decoration hover:underline" to="/privacy">
            Privacy
          </Link>
          <Link className="underline-decoration hover:underline" to="/terms">
            Terms
          </Link>
          <ThemeControl className="sm:hidden" />
        </div>
      </footer>
    </div>
  );
}
